import Vue from 'vue'
import Router from 'vue-router'

import PackageChoiceScreen from '../components/PackageChoiceScreen.vue'
import SerialScreen from '../components/SerialScreen.vue'
import PaymentScreen from '../components/PaymentScreen.vue'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '*',
            name: "PackageChoice",
            component: PackageChoiceScreen
        },
        {
            path: '/serial',
            name: "Serial",
            component: SerialScreen
        },
        {
            path: '/checkout',
            name: "Checkout",
            component: PaymentScreen
        }
    ]
})